//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {},

  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
  },
};
